/**
 * Helpers to test if Vue object is empty
 */

/**
 * Global Mixin
 * Available within vue components
 * Usage:
 * if (this.obj({myObject})) {}
 */

export const ObjMixin = {
  install (Vue, options) {
    Vue.mixin({
      methods: {
        obj (testObject) {
          return Object.keys(testObject).length !== 0
        }
      }
    })
  }
}

/**
 * Utility
 * Use outside of components
 * Usage:
 * if (this.obj({myObject}))
 */

export const obj = testObject => {
  return Object.keys(testObject).length !== 0
}
